import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {filterArticle_template} from "./filterArticle_template";
import {amCharts_v4_category_line_template} from "./amCharts_v4_category_line_template";
import {presetFilter_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template";
import {exportDataCsv} from "../../../vendor/valnet/valnet_jslib/vnHelpers/exportDataCsv";

declare var ko: any;

export class updateComparison_template extends vnTemplate{

    protected brandsFilter : multipleSelector_template;
    protected postInitiativesFilter : multipleSelector_template;
    protected postIntentsFilter : multipleSelector_template;
    protected postContentTypesFilter : multipleSelector_template;
    protected networkCategoriesFilter : multipleSelector_template;
    protected datesFilter: filterDate_template;
    protected filterArticle: filterArticle_template;
    protected chart: amCharts_v4_category_line_template;
    protected exportUpdateComparisonDataCsv: exportDataCsv;

    public validationsList: validationsList_template;
    public presetFilter: presetFilter_template;

    protected simpleFilter: filterSimple_template;
    protected pagination: pagination_template;
    protected resultsInfo: resultsInfo_template;

    readonly dataRanges = [
        { "id": 30, "name": "30"},
        { "id": 45, "name": "45"},
        { "id": 60, "name": "60"}
    ];

    //
    // implementation of base class [vnTemplate]
    protected getTemplateHtml(): string{

        return  `
            <div class="sub-header w-justify">
                ` + this.presetFilter.getHtmlBuild() + `
               
                <div class="w-left">
                    ` + this.brandsFilter.getHtmlBuild() + ` 
                    ` + this.postInitiativesFilter.getHtmlBuild() + ` 
                    ` + this.postIntentsFilter.getHtmlBuild() + ` 
                    ` + this.postContentTypesFilter.getHtmlBuild() + ` 
                    ` + this.networkCategoriesFilter.getHtmlBuild() + `
                    ` + this.datesFilter.getHtmlBuild() + `
                    ` + this.filterArticle.getHtmlBuild() + `
                    ` + this.simpleFilter.getHtmlBuild() + `
                
                    <div class="dropdown select-single">
                        <label class="form-label" for="">data Range (days)</label>
                        <button class="dropdown-toggle" type="button" data-bind="text: dataRangeSelected"></button>
                        
                        <div class="dropdown-list"> 
                            <div class="w-form">   
                                <div class="form-group" data-bind="foreach: dataRanges">
                                    <input type="radio" data-bind="checked : $parent.dataRangeSelected, value: id,  attr: { 'id': 'data_range_' + id, 'name' : 'data_range_' + id }, event:{ change: $parent.onDataRangeChange}">
                                    <label class="form-label" data-bind="attr: {for : 'data_range_' + id }, text: name"></label>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                
                </div>

            </div>
            
            ` + this.validationsList.getHtmlBuild()  + `
                        
             <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                   <div id="selected-brands"></div>
                   <div id="selected-initiatives"></div>
                   <div id="selected-intents"></div>
                   <div id="selected-content_types"></div>
                   <div id="selected-network_categories"></div>
                </div>   
            </div>
            
            <div class="list-header w-justify">
                <div class="w-left">
                    <h2 class="section-title icon i-compare">Update Comparison Tool</h2>
                </div>
            </div>
                           
 
            
            <section class="w-graph"  data-bind="css: { loading: isGraphLoading }">
                ` + this.chart.getHtmlBuild() + `
            </section>
                        
            <div class="w-list-results"  id="graph-results"  data-bind="css: { loading: isGraphLoading }">
            
                <table class="list-results">
                    <thead>
                        <tr>
                            <th><span>Pageviews Before</span></th>
                            <th><span>Pageviews After</span></th>
                            <th><span>Pageview Diff %</span></th>
                            <th><span>Sessions Before</span></th>
                            <th><span>Sessions After</span></th>
                            <th><span>Sessions Diff %</span></th>
                            <th><span>clicks Before</span></th>
                            <th><span>clicks After</span></th>
                            <th><span>Clicks Diff %</span></th>
                            <th><span>Update Count</span></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><span data-bind="text: pageviewsBefore"></span></td>
                            <td><span data-bind="text: pageviewsAfter"></span></td>
                            <td><span data-bind="text: pageviewsRatio"></span></td>
                            <td><span data-bind="text: sessionsBefore"></span></td>
                            <td><span data-bind="text: sessionsAfter"></span></td>
                            <td><span data-bind="text: sessionsRatio"></span></td>
                            <td><span data-bind="text: clicksBefore"></span></td>
                            <td><span data-bind="text: clicksAfter"></span></td>
                            <td><span data-bind="text: clicksRatio"></span></td>
                            <td><span data-bind="text: republishedCount"></span></td>
                        </tr>
                    </tbody>
                </table>
                <div class="list-header w-justify" style="margin-top:50px;">
                    <h2 class="section-title icon i-article">Updated Articles List</h2>
                    <div class="w-right"> 
                        ` + this.pagination.getHtmlBuild() + `
                        <button class="btn icon highlight i-export" type="button" data-bind="event: { click: exportData}, css: { 'is-hidden': exportButtonHidden }">Export</button>
                    </div>
                </div>
                
                <div class="w-list-results content_buckets" data-bind="css: { loading: isLoading }">
                                       
                    <table class="list-results list-logs" id="list-results">
                        ` + this.resultsInfo.getHtmlBuild() + `
                        <thead>
                            <input data-bind="value: orderBy" type="hidden">
                            <input data-bind="value: orderByDirection" type="hidden">
                            <tr>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'title') }, css: { 'list-sort-desc': orderByAndDirection()=='title_DESC', 'list-sort-asc': orderByAndDirection()=='title_ASC' }" class="icon i-dropdown-simple">Title</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'brandShortName') }, css: { 'list-sort-desc': orderByAndDirection()=='brandShortName_DESC', 'list-sort-asc': orderByAndDirection()=='brandShortName_ASC' }" class="icon i-dropdown-simple">Brand</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'articleDateRepublished') }, css: { 'list-sort-desc': orderByAndDirection()=='articleDateRepublished_DESC', 'list-sort-asc': orderByAndDirection()=='articleDateRepublished_ASC' }" class="icon i-dropdown-simple">Updated Date</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'writerName') }, css: { 'list-sort-desc': orderByAndDirection()=='writerName_DESC', 'list-sort-asc': orderByAndDirection()=='writerName_ASC' }" class="icon i-dropdown-simple">Author</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'jrEditorName') }, css: { 'list-sort-desc': orderByAndDirection()=='jrEditorName_DESC', 'list-sort-asc': orderByAndDirection()=='jrEditorName_ASC' }" class="icon i-dropdown-simple">Jr Editor</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'editorName') }, css: { 'list-sort-desc': orderByAndDirection()=='editorName_DESC', 'list-sort-asc': orderByAndDirection()=='editorName_ASC' }" class="icon i-dropdown-simple">Sr Editor</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'initiativeName') }, css: { 'list-sort-desc': orderByAndDirection()=='initiativeName_DESC', 'list-sort-asc': orderByAndDirection()=='initiativeName_ASC' }" class="icon i-dropdown-simple">Initiative</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'intentName') }, css: { 'list-sort-desc': orderByAndDirection()=='intentName_DESC', 'list-sort-asc': orderByAndDirection()=='intentName_ASC' }" class="icon i-dropdown-simple">Intent</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'contentTypeName') }, css: { 'list-sort-desc': orderByAndDirection()=='contentTypeName_DESC', 'list-sort-asc': orderByAndDirection()=='contentTypeName_ASC' }" class="icon i-dropdown-simple">Content Type</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'networkCategoryName') }, css: { 'list-sort-desc': orderByAndDirection()=='networkCategoryName_DESC', 'list-sort-asc': orderByAndDirection()=='networkCategoryName_ASC' }" class="icon i-dropdown-simple">Network Category</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'pageviewsAfter') }, css: { 'list-sort-desc': orderByAndDirection()=='reviewsAfter_DESC', 'list-sort-asc': orderByAndDirection()=='reviewsAfter_ASC' }" class="icon i-dropdown-simple">Pageviews After</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'pageviewsEvolution') }, css: { 'list-sort-desc': orderByAndDirection()=='reviewEvolution_DESC', 'list-sort-asc': orderByAndDirection()=='reviewEvolution_ASC' }" class="icon i-dropdown-simple">Pageviews Diff %</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'sessionsAfter') }, css: { 'list-sort-desc': orderByAndDirection()=='sessionsAfter_DESC', 'list-sort-asc': orderByAndDirection()=='sessionsAfter_ASC' }" class="icon i-dropdown-simple">Sessions After</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'sessionsEvolution') }, css: { 'list-sort-desc': orderByAndDirection()=='sessionsEvolution_DESC', 'list-sort-asc': orderByAndDirection()=='sessionsEvolution_ASC' }" class="icon i-dropdown-simple">Sessions Diff %</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'clicksAfter') }, css: { 'list-sort-desc': orderByAndDirection()=='clicksAfter_DESC', 'list-sort-asc': orderByAndDirection()=='clicksAfter_ASC' }" class="icon i-dropdown-simple">Clicks After</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'clicksEvolution') }, css: { 'list-sort-desc': orderByAndDirection()=='clicksEvolution_DESC', 'list-sort-asc': orderByAndDirection()=='clicksEvolution_ASC' }" class="icon i-dropdown-simple">clicks Diff %</span></th>
                            </tr>
                        </thead>
                        <tbody data-bind="foreach: updatedArticles">
                            <tr data-bind="event: { click: $parent.onClickRowClick.bind($data, $index(), $data) }, css: { 'is-clicked': $parent.selectedRows().indexOf($index()) !== -1}">
                                <td class="title"><span data-bind="text: title"></span></td>
                                <td class="shortName"><span data-bind="text: brandShortName"></span></td>
                                <td class="dateUpdated"><span data-bind="text: articleDateRepublished"></span></td>
                                <td class="fullName"><span data-bind="text: writerName"></span></td>
                                <td class="jrEditorName"><span data-bind="text: jrEditorName"></span></td>
                                <td class="editorName"><span data-bind="text: editorName"></span></td>
                                <td class="initiativeName"><span data-bind="text: initiativeName"></span></td>
                                <td class="intentName"><span data-bind="text: intentName"></span></td>
                                <td class="contentTypeName"><span data-bind="text: contentTypeName"></span></td>
                                <td class="networkCategoryName"><span data-bind="text: networkCategoryName"></span></td>
                                <td class="reviewsAfter"><span data-bind="text: pageviewsAfter"></span></td>
                                <td class="reviewEvolution"><span data-bind="text: Number(pageviewsEvolution).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                                <td class="sessionsAfter"><span data-bind="text: sessionsAfter"></span></td>
                                <td class="sessionEvolution"><span data-bind="text: Number(sessionsEvolution).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                                <td class="clicksAfter"><span data-bind="text: clicksAfter"></span></td>
                                <td class="clicksEvolution"><span data-bind="text: Number(clicksEvolution).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>                  
                            </tr>
                        <tbody>
                    </table>
                </div>
            </div>
            `;
    }

    //
    // implementation of base class [vnTemplate]
    protected getTemplateName(): string{
        return "updateComparison_template";
    }

    //
    // implementation of base class [vnTemplate]
    protected getMainElementClasses(): Array<string>{
        return [""];
    }

    //
    // implementation of base class [vnTemplate]
    protected initPartial(): void {

        this.presetFilter = new presetFilter_template("presetFilter", this.getTemplateViewModel(), this.caller);
        this.presetFilter.setType('updateComparison');

        this.brandsFilter = new multipleSelector_template("brandsFilter", this.getTemplateViewModel(), this.caller);
        this.brandsFilter.setTagContainerId('selected-brands');
        this.brandsFilter.setTagContainerCaption('Selected brands:');
        this.brandsFilter.setLogoEnabled(true);

        this.postInitiativesFilter = new multipleSelector_template("postInitiativesFilter", this.getTemplateViewModel(), this.caller);
        this.postInitiativesFilter.setLabel("Mappings");
        this.postInitiativesFilter.setFilterContainerClass('margin-neg');
        this.postInitiativesFilter.setTagContainerId('selected-initiatives');
        this.postInitiativesFilter.setTagContainerCaption('Selected mappings:');

        this.postIntentsFilter = new multipleSelector_template("postIntentsFilter", this.getTemplateViewModel(), this.caller);
        this.postIntentsFilter.setLabel("Intents");
        this.postIntentsFilter.setFilterContainerClass('margin-neg');
        this.postIntentsFilter.setTagContainerId('selected-intents');
        this.postIntentsFilter.setTagContainerCaption('Selected intents:');

        this.postContentTypesFilter = new multipleSelector_template("postContentTypesFilter", this.getTemplateViewModel(), this.caller);
        this.postContentTypesFilter.setLabel("content types");
        this.postContentTypesFilter.setTagContainerId('selected-content_types');
        this.postContentTypesFilter.setTagContainerCaption('Selected content types:');

        this.networkCategoriesFilter = new multipleSelector_template("networkCategoriesFilter", this.getTemplateViewModel(), this.caller);
        this.networkCategoriesFilter.setLabel("network categories");
        this.networkCategoriesFilter.setTagContainerId('selected-network_categories');
        this.networkCategoriesFilter.setTagContainerCaption('Selected network categories:');

        this.filterArticle = new filterArticle_template("filterArticle", this.getTemplateViewModel(), this.caller);

        this.simpleFilter = new filterSimple_template('simpleFilter', this.getTemplateViewModel(), this.caller);

        this.resultsInfo  = new resultsInfo_template('resultsInfo', this.getTemplateViewModel(), this.caller);

        this.pagination   = new pagination_template('pagination', this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;

        this.datesFilter = new filterDate_template("datesFilter", this.getTemplateViewModel(), this.caller);
        this.setDateRange(30);

        this.chart = new amCharts_v4_category_line_template("updateComparison", this.getTemplateViewModel(), this.caller);

        this.exportUpdateComparisonDataCsv = new exportDataCsv();

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this);
    }

    //
    // implementation of base class [vnTemplate]
    public buildViewModel(){

        // define the viewModel data/ functions
        let huit_neuf_this = this;

        return  {
            userBrands: ko.observableArray([]),
            pageviewsBefore: ko.observable(0),
            pageviewsAfter: ko.observable(0),
            pageviewsRatio: ko.observable(0 + "%"),
            sessionsBefore: ko.observable(0),
            sessionsAfter: ko.observable(0),
            sessionsRatio: ko.observable(0 + "%"),
            clicksBefore: ko.observable(0),
            clicksAfter: ko.observable(0),
            clicksRatio: ko.observable(0 + "%"),
            republishedCount: ko.observable(0),
            isLoading: ko.observable(0),
            isGraphLoading: ko.observable(0),
            isFinancialDataAccessible : ko.observable(0),
            orderBy: ko.observable('pageviewsAfter'),
            orderByDirection: ko.observable("DESC"),
            orderByAndDirection: ko.observable("pageviewsAfter_DESC"),
            updatedArticles: ko.observableArray([]),
            dataRanges : ko.observableArray([]),
            dataRangeSelected : ko.observable(30),
            exportButtonHidden : ko.observable(1),
            CSVUpdateComparisonData : ko.observableArray([]),
            selectedRows : ko.observableArray([]),
            onClickReorder: function (value, data, event) {
                huit_neuf_this.onClickReorder(value, data, event);
            },
            onDataRangeChange: function (data) {
                huit_neuf_this.onDataRangeChange(data);
            },
            exportData: function () {
                huit_neuf_this.getCsvData(huit_neuf_this);
            },
            onClickRowClick: function(index, data){
                huit_neuf_this.onClickRowClick(index);
                return true;
            },
        };
    }

    onClickReorder(value, data, event) {
        this.getTemplateViewModel().orderBy(value);
        if( this.getTemplateViewModel().orderByDirection() == "DESC" ){
            this.getTemplateViewModel().orderByDirection("ASC");
        }
        else{
            this.getTemplateViewModel().orderByDirection("DESC");
        }
        this.getTemplateViewModel().orderByAndDirection(value + "_" + this.getTemplateViewModel().orderByDirection());
        this.caller.reorderUpdatedPages();
    }

    public getViewModelForRequest(){

        return   {
            brands: this.getTemplateViewModel().brandsFilter.selectedItems(),
            postInitiatives: this.getTemplateViewModel().postInitiativesFilter.selectedItems(),
            postIntents: this.getTemplateViewModel().postIntentsFilter.selectedItems(),
            postContentTypes: this.getTemplateViewModel().postContentTypesFilter.selectedItems(),
            networkCategories: this.getTemplateViewModel().networkCategoriesFilter.selectedItems(),
            dateFilterType: this.getTemplateViewModel().datesFilter.selectedFilter(),
            startDate: this.getTemplateViewModel().datesFilter.startDate(),
            endDate: this.getTemplateViewModel().datesFilter.endDate(),
            startDateRange: this.getTemplateViewModel().datesFilter.fromRange(),
            endDateRange: this.getTemplateViewModel().datesFilter.toRange(),
            filterArticle: this.getTemplateViewModel().filterArticle.articleObjLite(),
            keyword: this.simpleFilter.getTemplateViewModel().filterKeyword(),
            pagination: this.getTemplateViewModel().pagination,
            orderBy: this.getTemplateViewModel().orderBy(),
            orderByDirection: this.getTemplateViewModel().orderByDirection(),
            dataRange: this.getTemplateViewModel().dataRangeSelected(),
        }
    }

    public activateLoading(){

        this.getTemplateViewModel().isLoading(1);
    }

    public deactivateLoading(){

        this.getTemplateViewModel().isLoading(0);
    }

    public activateGraphLoading(){

        this.getTemplateViewModel().isGraphLoading(1);
    }

    public deactivateGraphLoading(){

        this.getTemplateViewModel().isGraphLoading(0);
    }

    //build the date Picker calendar
    public buildDatePickerCalendar(){
        this.datesFilter.buildCalendar();
    }

    public setUserBrands(userBrands){
        let brands = [];
        for (let brand of userBrands) {
            brands.push(brand['id']);
        }
        this.getTemplateViewModel().userBrands(brands);
    }

    public setBrandFilterItems(departments){
        let groups = [];
        for ( let department of departments){
            let group = {"name" : department.name, "logo" : department.logo, "items" : department.brands};
            groups.push(group);
        }
        this.brandsFilter.setMultiSectionItems(groups);
        this.brandsFilter.setLabel('Brands');
    }

    public setPostInitiativesFilterItems(items){
        for (let item of items){
            item['name'] = item['initiative'];
        }
        items.unshift({'id': 0, 'name' : 'no mappings'});
        this.postInitiativesFilter.setItems(items);
    }

    public setPostIntentsFilterItems(items){
        for (let item of items){
            item['name'] = item['name'];
        }
        items.unshift({'id': 0, 'name' : 'no intents'});
        this.postIntentsFilter.setItems(items);
    }

    public setPostContentTypesFilterItems(items){

        items.unshift({id: 0, name: 'no post types', contentTypes: [{id: 0, name: 'no post types'}]});

        let groups = [];
        for (let groupedContentType of items){

            let group = {"name" : groupedContentType.name, "items" : groupedContentType.contentTypes};
            groups.push(group);
        }

        this.postContentTypesFilter.setMultiSectionItems(groups);
        this.postContentTypesFilter.setLabel('Content Types');
    }

    public setNetworkCategoriesFilterItems(items){

        items.unshift({id: 0, name: 'no network categories', networkCategories: [{id: 0, name: 'no network categories'}]});

        let groups = [];
        for (let groupedNetworkCategory of items){

            let group = {"name" : groupedNetworkCategory.name, "items" : groupedNetworkCategory.networkCategories};
            groups.push(group);
        }

        this.networkCategoriesFilter.setMultiSectionItems(groups);
        this.networkCategoriesFilter.setLabel('Network Categories');
    }

    public setArticles(articles) {

        this.getTemplateViewModel().filterArticle.articles(articles);
    }
    public setUpdatedArticles(updatedArticles) {

        this.getTemplateViewModel().updatedArticles(updatedArticles);
        this.showExportButton();
    }

    public setPageNumber(pageNumber: number): void {
        this.pagination.getTemplateViewModel().pageNumber(pageNumber);
    }

    public setPagination(totalCount: number) {
        this.pagination.setNumberItemToPaginate(totalCount);
    }
    public setResultPage(nbResults, nbPages, execTime) {
        this.resultsInfo.setExecutionTime(execTime);
        this.resultsInfo.setNbResults(nbResults);
        this.resultsInfo.setNbPages(nbPages);
    }

    public updateGraphData(data) {

        let graphData = data.graphData;
        let summaryData = data.summaryData;

        // set xaxis
        this.chart.setCategory("period");
        this.chart.setMinGridDistance(20);

        let yaxis = [];
        yaxis.push({
            field: "pageviews",
            name: "Pageviews",
            axis: "main",
            color: "#1886ff",
            opposite: false
        });

        yaxis.push({
            field: "sessions",
            name: "Sessions",
            axis: "main",
            color: "#23ba6e",
            opposite: false
        });

        yaxis.push({
            field: "clicks",
            name: "Clicks",
            axis: "main",
            color: "#27caca",
            opposite: false
        });

        this.chart.setYaxis(yaxis);

        let ranges = [];
        ranges.push({
            category: "1",
            endCategory: "1",
            fill: "#E56163",
            fillOpacity: 1,
            locationsCategory: 0.45,
            locationsEndCategory: 0.55,
        });

        this.chart.setRanges(ranges);


        this.chart.drawChart(graphData);

        this.getTemplateViewModel().pageviewsBefore(Number(summaryData.pageviewsBefore).toLocaleString('en-us'));
        this.getTemplateViewModel().pageviewsAfter(Number(summaryData.pageviewsAfter).toLocaleString('en-us'));

        if (data.pageviewsBefore != 0) {
            this.getTemplateViewModel().pageviewsRatio(Number(((summaryData.pageviewsAfter - summaryData.pageviewsBefore) / (summaryData.pageviewsBefore) * 100).toFixed(2)).toLocaleString('en-us') + "%");
        }else {
            this.getTemplateViewModel().pageviewsRatio(0 + "%");
        }

        this.getTemplateViewModel().sessionsBefore(Number(summaryData.sessionsBefore).toLocaleString('en-us'));
        this.getTemplateViewModel().sessionsAfter(Number(summaryData.sessionsAfter).toLocaleString('en-us'));

        if (summaryData.sessionsBefore != 0) {
            this.getTemplateViewModel().sessionsRatio(Number(( (summaryData.sessionsAfter - summaryData.sessionsBefore) / (summaryData.sessionsBefore) * 100 ).toFixed(2)).toLocaleString('en-us') + "%");
        }else {
            this.getTemplateViewModel().sessionsRatio(0 + "%");
        }

        this.getTemplateViewModel().clicksBefore(Number(summaryData.clicksBefore).toLocaleString('en-us'));
        this.getTemplateViewModel().clicksAfter(Number(summaryData.clicksAfter).toLocaleString('en-us'));

        if (summaryData.clicksBefore != 0) {
            this.getTemplateViewModel().clicksRatio(Number(( (summaryData.clicksAfter - summaryData.clicksBefore) / (summaryData.clicksBefore) * 100 ).toFixed(2)).toLocaleString('en-us') + "%");
        }else {
            this.getTemplateViewModel().clicksRatio(0 + "%");
        }

        this.getTemplateViewModel().republishedCount(Number(summaryData.republishedCount).toLocaleString('en-us'));
    }

    protected onBlurArticle(data, event) {

        this.getTemplateViewModel().article(data.title)
        this.getTemplateViewModel().idItem(data.id);
        this.getTemplateViewModel().isShowArticleSuggestions(false);
    }

    public setFinancialPermissions(isFinancialDataAccessible){

        this.getTemplateViewModel().isFinancialDataAccessible(isFinancialDataAccessible);
    }

    public setViewModelFromRequest(params : Array<any>): void{

        this.presetFilter.setMultiSelectorPresetFilters(this.brandsFilter, params['brands']);
        this.presetFilter.setMultiSelectorPresetFilters(this.postInitiativesFilter, params['postInitiatives']);
        this.presetFilter.setMultiSelectorPresetFilters(this.postIntentsFilter, params['postIntents']);
        this.presetFilter.setMultiSelectorPresetFilters(this.postContentTypesFilter, params['postContentTypes']);
        this.presetFilter.setMultiSelectorPresetFilters(this.networkCategoriesFilter, params['networkCategories']);

        this.filterArticle.setViewModelFromRequest(params['filterArticle']);

        this.presetFilter.setDates(this.datesFilter, params['dateFilterType'], params['startDate'], params['endDate'], params['startDateRange'], params['endDateRange']);

        if(typeof params['dataRange'] !== 'undefined'){

            this.getTemplateViewModel().dataRangeSelected(params['dataRange'])
        }

        if(typeof params['keyword'] !== 'undefined'){

            this.simpleFilter.getTemplateViewModel().filterKeyword(params['keyword'])
        }

        if(typeof params['dataRange'] !== 'undefined'){

            this.getTemplateViewModel().dataRangeSelected(params['dataRange']);
        }
    }

    public setDataRangesItems(){

        this.getTemplateViewModel().dataRanges(this.dataRanges);
    }

    private onDataRangeChange(data){

        this.setDateRange(data.id);
        this.caller.getGraphData();
    }

    private setDateRange(range){

        let startDate = new Date();
        let startRange = range + 8;
        startDate.setHours(0,0,0,0);
        startDate.setDate(startDate.getDate() - startRange);

        let endDate= new Date();
        let endRange = range + 1;
        endDate.setHours(0,0,0,0);
        endDate.setDate(endDate.getDate() - endRange);

        this.datesFilter.setDateRange(startDate, endDate);
    }

    public setCsvExportData(dataForCsvExport){

        let exportDataView = [];
        for (let exportDataRow of dataForCsvExport) {

            let exportDataViewRow = [];
            exportDataViewRow["Title"] = exportDataRow.title;
            exportDataViewRow["Brand"] = exportDataRow.brandShortName;
            exportDataViewRow["Updated Date"] = exportDataRow.articleDateRepublished;
            exportDataViewRow["Author"] = exportDataRow.writerName;
            exportDataViewRow["Jr Editor"] = exportDataRow.jrEditorName;
            exportDataViewRow["Sr Editor"] = exportDataRow.editorName;
            exportDataViewRow["Initiative"] = exportDataRow.initiativeName;
            exportDataViewRow["Intent"] = exportDataRow.intentName;
            exportDataViewRow["Content Type"] = exportDataRow.contentTypeName;
            exportDataViewRow["Network Category"] = exportDataRow.networkCategoryName;
            exportDataViewRow["Pageviews After"] = exportDataRow.pageviewsAfter;
            exportDataViewRow["Pageviews Diff %"] = Number(exportDataRow.pageviewsEvolution).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%';
            exportDataViewRow["Sessions After"] = exportDataRow.sessionsAfter;
            exportDataViewRow["Sessions Diff %"] = Number(exportDataRow.sessionsEvolution).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%';
            exportDataViewRow["Clicks After"] = exportDataRow.clicksAfter;
            exportDataViewRow["clicks Diff %"] = Number(exportDataRow.clicksEvolution).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%';

            exportDataView.push(exportDataViewRow);
        }

        this.getTemplateViewModel().CSVUpdateComparisonData(exportDataView);
    }

    private exportCsvData(){

        let fileName = "update_comparison_data_" + this.datesFilter.getTemplateViewModel().startDate() + "_" + this.datesFilter.getTemplateViewModel().endDate()+ ".csv";
        this.exportUpdateComparisonDataCsv.exportToCsv(fileName, this.getTemplateViewModel().CSVUpdateComparisonData());
    }

    public hideExportButton(){

        this.getTemplateViewModel().exportButtonHidden(1);
    }

    public showExportButton(){

        this.getTemplateViewModel().exportButtonHidden(0);
    }

    private getCsvData(obj){

        this.caller.getArticlesListForCSV();
    }

    private onClickRowClick(index){

        let selectedRows = this.getTemplateViewModel().selectedRows();
        let check = selectedRows.indexOf(index);

        if (check !== -1) {

            selectedRows.splice(check, 1);
        }else {

            selectedRows.push(index);
        }

        this.getTemplateViewModel().selectedRows(selectedRows);
    }

    public resetSelectedRows(){

        this.getTemplateViewModel().selectedRows([]);
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/updateComparison_template.ts